import { useEffect } from 'react'
import { usePortfolio } from '../context/PortfolioContext'

/**
 * Hook to manage chat drawer state when navigating to case studies
 * - If navigated FROM chat: keep chat open (desktop only)
 * - If navigated FROM main content: close chat
 */
export function useCaseStudyNavigation() {
  const {
    navigatedFromChat,
    setNavigatedFromChat,
    closeChatDrawer,
    isChatDrawerOpen,
  } = usePortfolio()

  useEffect(() => {
    // If we didn't navigate from chat and chat is open, close it
    // This handles navigation from main content (project cards, navigation, etc.)
    if (!navigatedFromChat && isChatDrawerOpen && window.innerWidth >= 1024) {
      closeChatDrawer()
    }

    // Reset the flag after checking
    return () => {
      setNavigatedFromChat(false)
    }
  }, []) // Only run on mount

  return null
}
